/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";
import "datatables.net-bs4";
import "datatables.net-buttons-bs4";

/*------------------------------------*\
    BULL LIST MODULE
\*------------------------------------*/
class BullList {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = $(this);

        $(document).on("ready", function () {
            var elem = $(this),
                tableElem = elem.find('.js-bull-list__table'),
                orderColumn = tableElem.find('.js-bull-list__order-column'),
                orderColumnIndex = orderColumn.index(),
                orderSort = orderColumn.attr('data-sort'),
                checkboxColumnIndex = tableElem.find('.js-bull-list__checkbox-column').index(),
                linkColumnIndex = tableElem.find('.js-bull-list__link-column').index(),
                detailToggleColumn = tableElem.find('.js-bull-list__detail-toggle-column'),
                detailToggleColumnIndex = detailToggleColumn.index();
                //emptyErrorMessage = elem[0].getAttribute('data-empty-message');

            // Instantiate DataTables
            var table = tableElem.dataTable({
                stateSave: false,
                order: [[orderColumnIndex, orderSort]],
                info: false,
                language: {
                    //emptyTable: emptyErrorMessage.length > 0 ? emptyErrorMessage : 'There are currently no bulls in this list'
                },
                lengthChange: false,
                searching: false,
                pagingType: 'numbers',
                columnDefs: [
                    {
                        targets: [checkboxColumnIndex, linkColumnIndex],
                        orderable: false
                    },
                    {
                        targets: checkboxColumnIndex,
                        width: '18px'
                    },
                    {
                        targets: linkColumnIndex,
                        width: '18px'
                    },
                    {
                        targets: detailToggleColumnIndex,
                        width: '18px'
                    },
                    {
                        className: 'control',
                        orderable: false,
                        targets: detailToggleColumnIndex
                    }
                ],
                responsive: {
                    breakpoints: [
                        { name: 'xl', width: Infinity },
                        { name: 'lg', width: 1199 },
                        { name: 'md', width: 991 },
                        { name: 'sm', width: 767 },
                        { name: 'xs', width: 575 }
                    ],
                    details: {
                        'type': 'column',
                        target: detailToggleColumnIndex
                    }
                }
            });

            table.on('page.dt', function () {
                $('html, body').animate({
                    scrollTop: tableElem.offset().top - 70
                }, 200);
            });

            // Toggle row selected status when checkbox is changed
            $('.js-table-checkbox').on('change', function () {
                var self = $(this),
                    row = self.parents('tr');

                if (self.is(':checked')) {
                    row.addClass('table-primary');
                }
                else {
                    row.removeClass('table-primary');
                }
            });

            // Show all
            $(".js-bull-list__show-all").on('click', function () {                
                // Show all table rows
                tableElem.DataTable().page.len(-1).draw();

                // Hide the 'show all' button
                $(this).hide();

                // Hide the pagination
                elem.find('.dataTables_paginate').hide();
            });

            // CSV export
            $('.js-bull-list-csv-export').on('click', function () {
                if ($('.js-table-checkbox').length > 0) {
                    var entriesArray = [];

                    if ($('.js-table-checkbox:checked').length === 0) {
                        // No rows selected; get all rows
                        var entries = elem.find('.js-table-checkbox');
                    }
                    else {
                        // Rows selected; get only selected rows
                        var entries = elem.find('.js-table-checkbox:checked');
                    }

                    entries.each(function (index) {
                        entriesArray.push($(this).attr('name'));
                    });

                    let entriesString = entriesArray.join();

                    window.location.href = window.location.pathname + '/csv?entries=' + entriesString;
                }
                else {
                    alert('There is nothing to export.');
                }
            });

            // PDF export
            $('.js-bull-list-pdf-export').on('click', function () {
                var self = $(this),
                    url = self.data('url');

                if ($('.js-table-checkbox').length > 0) {
                    var entriesArray = [];

                    if ($('.js-table-checkbox:checked').length === 0) {
                        // No rows selected; get all rows
                        var entries = elem.find('.js-table-checkbox');
                    }
                    else {
                        // Rows selected; get only selected rows
                        var entries = elem.find('.js-table-checkbox:checked');
                    }

                    entries.each(function (index) {
                        entriesArray.push($(this).attr('name'));
                    });

                    let entriesString = entriesArray.join();

                    var pdfUrl = url.replace('[ENTRIES]', entriesString);

                    window.location.href = pdfUrl;
                }
                else {
                    alert('There is nothing to export.');
                }
            });
        });
    }
}

export default BullList;